<template>
    <b-container fluid>
        <b-row v-if="attachments.length">
            <b-col
                v-for="(image, idx) in attachments.slice(0, 4)"
                :key="`image${idx}`"
                cols="3"
            >
                <b-img
                    thumbnail
                    fluid
                    :src="image.url"
                    :alt="`Image ${idx}`"
                ></b-img>
            </b-col>
        </b-row>
        <b-row v-else>
            <b-col>No Attachments Uploaded!!</b-col>
        </b-row>
        <b-modal v-model="isVisible" hide-footer>
            <b-row>
                <b-col
                    v-for="(image, idx) in attachments"
                    :key="`image${idx}`"
                    cols="4"
                >
                    <b-card
                        :title="`Image${idx + 1}`"
                        :img-src="image.url"
                        :img-alt="`Image${idx}`"
                        img-top
                        tag="article"
                        style="max-width: 20rem"
                        class="mb-2"
                    >
                        <b-button
                            @delete-image="deleteImage(idx)"
                            variant="primary"
                            >Delete</b-button
                        >
                    </b-card>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <b-form-file
                        id="uploadData"
                        @change="uploadFile"
                    ></b-form-file>
                </b-col>
            </b-row>
        </b-modal>
    </b-container>
</template>

<script>
export default {
    props: { attachments: Array, value: Boolean },
    data() {
        return {
            isVisible: false,
        }
    },
    watch: {
        value: function (val) {
            this.isVisible = val
        },
        isVisible: function (val) {
            this.$emit('input', val)
        },
    },
    mounted() {
        this.$store.dispatch('js_report/fetchCredentials')
    },
    methods: {
        deleteImage(idx) {
            this.attachments.splice(idx, 1)
            this.$emit('update-attachments', [...this.attachments])
        },
        uploadFile(event) {
            const $this = this
            if (!navigator.geolocation) {
                console.log('problem with navigator')
            } else
                navigator.geolocation.getCurrentPosition(async p => {
                    console.log('coordinates', p)
                    const lat = p.coords.latitude
                    const long = p.coords.longitude

                    console.log(event.target.files)
                    const { key, name } = await $this.$store.dispatch(
                        's3files/s3upload',
                        event.target.files
                    )

                    const url = `${$this.$OMSStorageUrl}/${key}`
                    console.log({ key, name, url })
                    $this.attachments.push({ url, lat, long })
                    $this.$emit('update-attachments', [...$this.attachments])
                })
        },
    },
}
</script>